import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import IconTitleValue from "components/textValue/IconTitleValue";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import messages from "res/messages/farsi";
import Urls from "../../../connection/Urls";
import {CircularProgress, Divider} from "@material-ui/core";
import {callApi} from "../../../connection/ClientApi";
import {getLoadingSize, IsLP_MP, IsLP_MP_SP, IsLP_MP_SP_T} from "my-styles/media/media";
import IconTitleButton from "components/buttons/IconTitleButton";
import queryString from "query-string";

import ICUserAccount from 'res/images/user.png';
import ICBeforePayment from "res/images/before_payment.png";
import ICColors from "res/images/progress_colors.png";
import ICLogo from "res/images/logo_persian.png";
import ICPayment from "res/images/payment.png";
import ICError from "res/images/error.png";

export default function BeforeWalletPayment(props) {

    const history = useHistory()
    const urlParams = queryString.parse(props.location.search)

    const [isCancelled, setIsCancelled] = useState(false)
    const [walletPayment, setWalletPayment] = useState()
    const [ipgModel, setIpgModel] = useState()
    const [showLoading, setShowLoading] = useState(true)
    const [showError, setShowError] = useState(false)
    const [showButton, setShowButton] = useState(false)
    const [buttonText, setButtonText] = useState()
    const [buttonLink, setButtonLink] = useState()
    const [disabled, setDisabled] = useState(false)
    const [selectedPaymentGateway, setSelectedPaymentGateway] = useState()
    const [message, setMessage] = useState()

    function requestWalletPaymentInfo() {
        if (urlParams && urlParams.token) {
            let params = new FormData()
            params.append("token", urlParams.token)
            callApi(Urls.getWalletPaymentInfo, params, (data) => {
                if (isCancelled) return

                setWalletPayment(data)
                if (data.paymentGateways.length > 0) {
                    setSelectedPaymentGateway(data.paymentGateways[0])
                }
                setShowError(false)
            }, (data) => {
                setMessage(data.message)
                setShowError(true)
            }, () => {
                setShowLoading(true)
            }, () => {
                setShowLoading(false)
            })
        }
    }

    function requestSendWalletToInternetPayment() {
        let params = new FormData()
        params.append("token", urlParams.token)
        callApi(Urls.sendWalletToInternetPayment, params, (data) => {
            if (data.description === 200) {
                setIpgModel(data.ipgModel)
                document.getElementById("submit").click()
            } else if (data.description === 400) {
                props.onAlert(data.message)
            }
        }, (data) => {
            if (data.buttonText) {
                setButtonText(data.buttonText)
                setButtonLink(data.buttonLink)
                setShowButton(true)
            }
            setMessage(data.message)
            setShowLoading(false)
            setShowError(true)
        }, () => {
            setShowLoading(true)
        }, () => {
            setDisabled(false)
            setShowLoading(false)
        })
    }

    useEffect(() => {
        requestWalletPaymentInfo()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<div style={{backgroundColor: "var(--yellow_1)", height: IsLP_MP_SP() ? "80em" : "50em"}}>
        <div className="card" style={{
            height: "85%",
            width: "90%",
            position: "absolute",
            top: "7.5%",
            left: "5%"
        }}>
            {walletPayment && !showLoading && !showError &&
            <div>
                <div className="paddingTopSmall">
                    <img className="clickable appLogo"
                         src={ICLogo} alt=""
                         onClick={() => {
                             props.onNavigate(history, '/')
                         }}/>
                    <div style={{width: IsLP_MP_SP() ? "90%" : "80%"}}>
                        <img className="fullWidth" style={{height: 3}} src={ICColors} alt=""/>
                    </div>
                </div>
                <div style={IsLP_MP_SP() ? {display: "flex"} : {}}>
                    <div className="paddingSmall" style={{width: IsLP_MP() ? "65%" : "100%"}}>
                        <div style={{width: IsLP_MP_SP() ? "50%" : "100%"}}>
                            <IconTitleValue
                                valueClassName={"mediumTextBold"}
                                icon={<img src={ICUserAccount} alt="" className="xxSmallIcon marginTopXSmall"/>}
                                title={messages.description}
                                value={walletPayment.tempWalletTransaction.description}/>
                        </div>
                        <Divider style={IsLP_MP_SP() ? {} : {width: "93%"}}/>
                        <div className="fullWidth">
                            <div style={{width: "100%", marginTop: 5}}>
                                <IconTitleValue
                                    titleClassName="xLargeTextBold"
                                    valueClassName="xLargeTextBold"
                                    icon={<img src={ICPayment} alt="" className="xxSmallIcon  marginTopXSmall"/>}
                                    title={messages.priceNetTotal}
                                    value={parseFloat(walletPayment.tempWalletTransaction.current_value).toLocaleString() + " " + messages.priceUnit}/>
                            </div>
                            <div className={IsLP_MP_SP() ? "horizontalFullScreen" : ""}>
                                {walletPayment.paymentGateways &&
                                <div className="horizontalFullScreen">
                                    {walletPayment.paymentGateways.map((paymentGateway, index) => {
                                        return <div
                                            key={index}
                                            className={(selectedPaymentGateway && selectedPaymentGateway.id === paymentGateway.id) ?
                                                "marginSmall border_green" : "marginSmall border_white"}>
                                            <IconTitleButton
                                                fontSize="smallTextBold"
                                                isvertical={"true"}
                                                icon={<img className="smallIcon" src={paymentGateway.image} alt=""/>}
                                                title={paymentGateway.title}
                                                onClick={() => {
                                                    setSelectedPaymentGateway(paymentGateway)
                                                }}/>
                                        </div>
                                    })
                                    }
                                </div>
                                }
                                <div className={IsLP_MP_SP() ? "marginTopMedium" : "toLeft marginLeftSmall "}
                                     style={{display: "flex"}}>
                                    <div className="marginSmall">
                                        <IconTitleButtonRound
                                            backgroundcolor={"var(--red_4)"}
                                            height={IsLP_MP_SP() ? "2.8em" : "2.5em"}
                                            width={IsLP_MP_SP_T() ? "100px" : "100px"}
                                            fontSize="largeText"
                                            onClick={() => {
                                                window.location.replace(walletPayment.cancelLink)
                                            }}
                                            title={messages.cancel}/>
                                    </div>
                                    <div className="marginSmall">
                                        <IconTitleButtonRound
                                            disabled={disabled}
                                            backgroundcolor={"var(--blue_3)"}
                                            height={IsLP_MP_SP() ? "2.8em" : "2.5em"}
                                            fontSize="largeText"
                                            width={IsLP_MP_SP_T() ? "150px" : "120px"}
                                            onClick={() => {
                                                requestSendWalletToInternetPayment()
                                            }}
                                            title={messages.pay}/>
                                        {ipgModel &&
                                        <form style={{display: "none"}} method="post"
                                              action={ipgModel.link}
                                              encType="multipart/form-data">
                                            <input value={ipgModel.tokenIdentity} name="tokenIdentity"/>
                                            <button type="submit" id="submit">Launch</button>
                                        </form>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Divider style={IsLP_MP_SP() ? {} : {width: "93%"}}/>
                    </div>
                    {IsLP_MP() &&
                    <div style={{width: "35%"}}>
                        <img className="toLeft fullWidth" src={ICBeforePayment} alt=""/>
                    </div>
                    }
                </div>
            </div>
            }
            {showLoading &&
            <div className="center" style={{marginTop: "22%"}}>
                <div>
                    <CircularProgress size={getLoadingSize()}/>
                </div>
                <div className="largeTextBold marginTopMedium">
                    {messages.watingForPaymentInfo}
                </div>
            </div>
            }
            {showError && !showLoading &&
            <div className="center" style={{marginTop: "18%"}}>
                <div>
                    <img alt="" src={ICError} className="xxLargeIcon"/>
                </div>
                <div className="largeTextBold marginLarge">
                    {message}
                </div>
                {showButton &&
                <div className="marginSmall">
                    <IconTitleButtonRound
                        backgroundcolor={"var(--blue_3)"}
                        height={IsLP_MP_SP() ? "2.8em" : "2.5em"}
                        fontSize="largeText"
                        width={IsLP_MP_SP() ? "300px" : "250px"}
                        onClick={() => {
                            window.location.replace(buttonLink)
                        }}
                        title={buttonText}/>
                </div>
                }
            </div>
            }
        </div>
    </div>)

}